import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ShopByMobileFilterBarButton = ({
  children,
  className,
  isOpen,
  onClick,
}) => (
  <span
    role="button"
    tabIndex={0}
    className={classNames(
      `text-sm font-bold items-center bg-white border-[1px] border-gray-light6 rounded-sm text-gray flex justify-center p-3 ml-1.5 ${className}`,
      {
        '!border-brand': isOpen,
      }
    )}
    onClick={() => onClick()}
  >
    {children}
  </span>
);

export default ShopByMobileFilterBarButton;

ShopByMobileFilterBarButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
};
